module.exports = __webpack_public_path__ + "img/p2.826e1d09.png";